import React, { useState } from "react";
import {
    Card,
    Typography,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Avatar,
    Box,
    IconButton,
    Collapse,
    Divider,
} from "@mui/material";
import { useQueryWithStore } from "react-admin";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const getBranchCode = () => {
    try {
        return localStorage.token ? jwt_decode(localStorage.token).branch_code : "";
    } catch (error) {
        console.error("Invalid token:", error);
        return "";
    }
};

const CollectionList = () => {
    const branch_code = getBranchCode();

    const { data: visitors, loaded } = useQueryWithStore({
        type: "getList",
        resource: "collection",
        payload: {
            filter: { branch_code },
            sort: { field: "name", order: "DESC" },
            pagination: { page: 1, perPage: 100 },
        },
    });

    if (!loaded) return null;
    if (!visitors?.length) return <Typography sx={{ p: 2, fontSize: 14 }}>No collection records found.</Typography>;

    return (
        <List sx={{ width: "100%" }}>
            {visitors.map((record, index) => (
                <React.Fragment key={record.id}>
                    <ListItem
                        button
                        component={Link}
                        to={`/processing/${record.id}`}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            p: 1.5,
                            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                        }}
                    >
                        <ListItemText
                            primary={record.name.toUpperCase()}
                            primaryTypographyProps={{ sx: { fontSize: "12px", fontWeight: "normal" } }}
                        />
                    </ListItem>
                    {index < visitors.length - 1 && <Divider />}
                </React.Fragment>
            ))}
        </List>
    );
};

const CollectionCom = () => {
    const [isOpen, setIsOpen] = useState(false);
    const branch_code = getBranchCode();

    const { data: visitors, loaded } = useQueryWithStore({
        type: "getList",
        resource: "collection",
        payload: {
            filter: { branch_code },
            sort: { field: "name", order: "DESC" },
            pagination: { page: 1, perPage: 100 },
        },
    });

    if (!loaded) return null;
    const collectionCount = visitors?.length || 0;

    return (
        <Box sx={{ p: 0 }}>
            <Card sx={{ borderRadius: 2, boxShadow: 3, p: 1, overflow: "hidden" }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center" gap={1}>
                        <PersonAddIcon sx={{ color: "navy", fontSize: 28 }} />
                        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "14px" }}>
                            Collection ({collectionCount})
                        </Typography>
                    </Box>
                    <IconButton onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                </Box>
                <Collapse in={isOpen}>
                    <Divider sx={{ my: 1 }} />
                    <CollectionList />
                </Collapse>
            </Card>
        </Box>
    );
};

export default CollectionCom;
